module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/notosanskr/notokr-regular.woff
// module id = wXCR
// module chunks = 0